import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { RoutesValues } from '@job-v2/ats-utils';
import { environment } from '../../../environments/environment';
import { AuthService } from '../../auth/auth.service';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {

    constructor(private router: Router, private authService: AuthService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            catchError((error: HttpErrorResponse) => {
                if (error.status === 404) {
                    this.router.navigate([RoutesValues.NOT_FOUND]);
                } else if (error.status === 403) {
                    this.router.navigate([RoutesValues.FORBIDDEN]);
                } else if (error.status === 401) {
                    this.authService.logout()
                }
                return throwError(() => error);
            })
        );
    }
}
